export class Login {
    UserName: string = '';
    Password: string = '';
    Domain: string = '';
}

export class ResponseResult {
    token: string;
    Token?: string;
    User: any;
    userName?: any;
    userSettingId?: any;
    userRoleId?: any;
    UserMenu?: Array<any>;
    domainName?: any;
    tokenGeneratedTime: any;
    tokenExpiredTime: any
}
